import { createSignal, createEffect, onCleanup } from 'solid-js';

interface SolariCharProps {
  char: string;
  delay?: number;
}

export default function SolariChar(props: SolariCharProps) {
  const [displayChar, setDisplayChar] = createSignal(props.char);
  const [flipping, setFlipping] = createSignal(false);

  createEffect(() => {
    const newChar = props.char;
    if (newChar !== displayChar()) {
      setFlipping(true);
      const timeout = setTimeout(() => {
        setDisplayChar(newChar);
        setTimeout(() => setFlipping(false), 150);
      }, 150 + (props.delay || 0));
      onCleanup(() => clearTimeout(timeout));
    }
  });

  return (
    <span
      class={`solari-char${flipping() ? ' solari-flipping' : ''}`}
    >
      {displayChar()}
      <span class="solari-char-line" />
    </span>
  );
}
